import {
  LogsEvent,
  LogsInitConfiguration,
  datadogLogs,
} from "@datadog/browser-logs";
import { CLIENT_TOKEN, DATADOG_SITE } from "./constants";

export type InitializeLogsProps = Partial<LogsInitConfiguration> & {
  service: string;
  sessionId: string;
};

export const initializeLogs = ({
  service,
  sessionId,
  ...rest
}: InitializeLogsProps) => {
  datadogLogs.init({
    clientToken: CLIENT_TOKEN,
    site: DATADOG_SITE,
    service,
    sessionSampleRate: 100,
    forwardErrorsToLogs: true,
    trackSessionAcrossSubdomains: true,
    beforeSend: (log: LogsEvent) => {
      log.browser_session_id = sessionId;
      log.path = window.location.pathname;

      return sanitizeLog(log);
    },
    ...rest,
  });
};

export function sanitizeLog(log: LogsEvent) {
  if (log.message) {
    if (shouldReject(log.message)) return false;

    log.message = filterPII(log.message);
  }
  if (log.error?.message) {
    log.error.message = filterPII(log.error.message);
  }

  return true;
}

const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g; // Simplifyed email regex for quick PII replacement, not using the one in "regex-constants" because in my testing is was kind of slow
function filterEmails(message: string) {
  return message.replace(emailRegex, "[REDACTED]");
}

const phoneRegex = /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}/; // Regex in the utility lib contains start/end of line token (^$) which we don't need here
function filterPhoneNumbers(message: string) {
  return message.replace(phoneRegex, "[REDACTED]");
}

function shouldReject(message: string) {
  // Theses messages often contains PII and should not be logged
  // We do not control the source of theses messages, as they only occurs for users using the Klarna browser.
  return (
    message.startsWith("Serialiser failed {") &&
    message.includes('"safeSerialisation": {')
  );
}

function filterPII(message: string) {
  return filterEmails(filterPhoneNumbers(message));
}
